/**
 *
 * Asynchronously loads the component for AdvisorConnect
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AdvisorConnect = lazyLoad(
  () => import('./index'),
  module => module.AdvisorConnect,
);
